import { BehaviorSubject, catchError, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginResponse } from '../responses/login-response';
import { Roles } from '../models';
import { Router } from '@angular/router';
import { SessionStorageService } from './session-storage.service';
import { SessionUser } from '../types/types';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private http: HttpClient,
    private router: Router,
    private sessionStorageService: SessionStorageService
  ) { }

  private readonly loginBehavior = new BehaviorSubject<boolean>(false);
  readonly login$ = this.loginBehavior.asObservable();

  checkRole(role: string): boolean {
    const roles = this.getCurrentUser()?.roles ?? [];
    return roles.includes(role);
  }

  getCurrentUser(): SessionUser {
    return this.sessionStorageService.getUser();
  }

  isAuthenticated(): boolean {
    return !!this.getCurrentUser();
  }

  isAdmin(): boolean {
    return this.checkRole(Roles.Admin);
  }

  login(login: { username: string, password: string }, provider?: string, tenantId?: string): void {
    const authApiUrl = environment.authApiUrl[!provider ? 'default' : provider];

    this.http.post<LoginResponse>(`${authApiUrl}/login`, {
      ...login,
      clientId: environment.clientId,
      tenantId
    }).pipe(
        catchError(() => {
          this.loginBehavior.next(false);
          return of(null);
        }))
      .subscribe(response => {
        if (response?.token) {
          this.sessionStorageService.setUser({
            email: response.user.email,
            roles: [...response.user.roles],
            tenantId: response.user.tenantId,
            language: response.user.language
          },
          response.token,
          provider);
          this.loginBehavior.next(true);
          if (environment.homeRedirectPath?.trim()) {
            this.router.navigate([environment.homeRedirectPath]);
          }
        }
      });
  }

  logout() {
    this.sessionStorageService.clear();
    this.router.navigate([environment.defaultRedirectPath?.trim() || '/login']);
    this.loginBehavior.next(false);
  }

}